module.exports = __webpack_public_path__ + "images/emoji/game_die.475ea71ce23d3eb758b1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/game_die.png
// module id = isUS
// module chunks = 1